import {
    Alert, Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import MDButton from '@components/MDButton';
import { useTranslation } from 'react-i18next';

interface Props {
    open: boolean;
    onClose: () => void;
}

// Cada passo é uma chave só, com título e texto, para o tradutor não remontar a frase.
const STEPS = ['quando', 'escrever', 'variaveis', 'aprovacao', 'editar'];

export const WhatsappTemplateHelp = ({ open, onClose }: Props) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="paper">
            <DialogTitle>{t('whatsappTemplates.ajuda.titulo')}</DialogTitle>
            <DialogContent dividers>
                <Alert severity="info" icon={false} sx={{ mb: 2 }}>
                    <Typography variant="caption">{t('whatsappTemplates.ajuda.resumo')}</Typography>
                </Alert>

                <Box sx={{ display: 'grid', gap: 2 }}>
                    {STEPS.map((step, index) => (
                        <Box key={step} sx={{ display: 'flex', gap: 1.5 }}>
                            <Box
                                sx={{
                                    minWidth: 24,
                                    height: 24,
                                    borderRadius: '50%',
                                    bgcolor: 'info.main',
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 12,
                                    fontWeight: 700,
                                }}
                            >
                                {index + 1}
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {t(`whatsappTemplates.ajuda.${step}.titulo`)}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {t(`whatsappTemplates.ajuda.${step}.texto`)}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>

                <Alert severity="warning" icon={false} sx={{ mt: 2 }}>
                    <Typography variant="caption">
                        {/* A variável vai como valor: o i18next interpola {{ }} e o exemplo sairia sem ela. */}
                        {t('whatsappTemplates.ajuda.exemplo', { variavel: '{{lead_name}}' })}
                    </Typography>
                </Alert>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="dark" onClick={onClose}>
                    {t('general.fechar')}
                </MDButton>
            </DialogActions>
        </Dialog>
    );
};
